import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import Dialog from '@components/Dialog';
import messages from './messages';

function OutOfDeliveryModal({
  open,
  showSearchForAddress,
  onSearchForAddressClick,
  onChangeAddressClick,
  onClose,
  intl: { formatMessage },
}) {
  return (
    <Dialog
      open={open}
      title={formatMessage(messages.title)}
      text={formatMessage(messages.subtitle)}
      firstButtonText={
        showSearchForAddress
          ? formatMessage(messages.searchForAddressButton)
          : ''
      }
      secondButtonText={formatMessage(messages.changeAddressButton)}
      onFirstOptionClick={onSearchForAddressClick}
      onSecondOptionClick={onChangeAddressClick}
      onClose={onClose}
    />
  );
}

OutOfDeliveryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  showSearchForAddress: PropTypes.bool,
  onSearchForAddressClick: PropTypes.func.isRequired,
  onChangeAddressClick: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  intl: intlShape,
};

OutOfDeliveryModal.defaultProps = {
  onClose() {},
  showSearchForAddress: true,
};

export default injectIntl(OutOfDeliveryModal);
